module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-flow-5-7e8cc76fea15be73d9c2f1becdefea53.png";